// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"556":"b024b62e","674":"811ce5b2"}[chunkId] + ".chunk.js";
};